import React from 'react';
import ReactSwitch, { ReactSwitchProps } from 'react-switch';

import ConfidenceLabel, { ConfidenceLabelProps } from '../ConfidenceLabel';
import styles from './Switch.module.css';
export type SwitchProps = ReactSwitchProps & ConfidenceLabelProps;

const Switch = ({
  confidenceAutomated,
  confidenceLevel,
  confidenceValue,
  onColor = '#2c7be5',
  ...rest
}: SwitchProps): JSX.Element => {
  return (
    <div className={styles.container}>
      <ReactSwitch
        onColor={onColor}
        {...rest}
        uncheckedIcon={false}
        checkedIcon={false}
        height={30}
        handleDiameter={24}
      />
      <ConfidenceLabel
        confidenceAutomated={confidenceAutomated}
        confidenceLevel={confidenceLevel}
        confidenceValue={confidenceValue}
      />
    </div>
  );
};

Switch.displayName = 'Switch';

export default Switch;
